import { proxy } from "valtio";
import * as THREE from "three";


const stateNavigation = proxy ({
    isClickNavi: false,
    waypointListOpen: false,
  waypointIndex: 0,
  waypointId: "",
  waypointSetId:"EntryRoom",
  wayCamPos: new THREE.Vector3(0,0,0),
  wayCamTargetPos: new THREE.Vector3 (0,0,0),
  wayCamSubPos: new THREE.Vector3(0,0,0),
  wayCamTargetSubPos: new THREE.Vector3(0,0,0),
  waypointSubId: "",
  wayPointSub: false,
  wayPointSubClicked: false,
    schaustelleIndex:"",
    slideBarActive:"true",
    annotationOverwrite:"",
     phantomQueue: [], 
  animatingPhantoms: false,
  pendingWaypoint: null,
  phantomEndToggle: false,
  cameraAnimationRuns: false,
    sidebarWidth: 450,
  sidebarHeight: 220,
  clickHintArtefaktTitels: {}, // { [titel]: true } — artefacts eligible for the mobile-portrait click-navi "tap me" bob hint, whose annotation label should stay hidden
})

const stateInArea = proxy ({
    inArea: false,
    inAreaIndex: "", 
    inAreaPastIndex:"",
    eisenZeitClck: false,
})

const stateInAreaRooms = proxy ({
    inAreaRoom: false,
    inAreaRoomEntryRoom: true,
   
})

const stateInAreaSchaustelle = proxy ({
    inAreaSchaustelle: false,
   
})

const stateOrbitLocation = proxy({
    orbitClicked: false,
    CameraPos: new THREE.Vector3(0,0,0),
    TargetPos: new THREE.Vector3 (0,0,0),
    shouldUpdate: true,
    lerpRuns: false


})

const statePlayerPositionS = proxy ({
// playerPositionS: new THREE.Vector3(0, 0, -150),
// playerRotationS: new THREE.Euler(0, 0, 0),
// playerRotationS: new THREE.Euler(0, 0, 0),
playerPositionS: new THREE.Vector3 (-150, 0, 0),
playerRotationS: new THREE.Euler(0, 1.65, 0),

playeractive: true,
playerCameraTargetPosition: new THREE.Vector3(0,0,0),
fpPlayer: false,
playerInput: false,
homeclicked: false,
travelclicked:false,
blockPlayerTravel: true,
homeFinished: true,
teleportScreen: false,
isTracking: false


})

const stateUiDisplay = proxy({
    storyTextMatch: false,
    orbitData: false,
    openInfoWindow: false,
   
})

const stateDevice = proxy({
    isMobile: false,
    isTablet: false,
    isIphone: false,
    isHandy:false,
    isSafari: false,
    isPortrait: false
})

const stateTouchCircle = proxy(
    {
        x: 0,
        y: 0,
       joystickMove: false
    }
) 

const stateTouchCircleLook = proxy(
    {
        x: 0,
        y: 0,
        OrbitOn:false,
        // JoystickLookOn:false,
        JoystickLookVisible: true
       
    }
) 

const stateWallPush = proxy(
    {
        activeThemeIndex: -1,
        visibleThemeIndex: -1,
    }
)


const statedynamicLight = proxy(
    {
        videoLight: false
    }
)

const stateLoadingScreen = proxy(

    {
        loadingScreenAnimate: true,
       lastInfoWindowClick: false,
        baseLoaded:false,
        basePercent: 0,
        showLoaderRooms: false,
        startPressed: false,
        exitComplete: false
       
    }
)

const stateIframeWindow = proxy(

    {
        showIframe: false,
        showIframeScetch: false,
        src: "",
        renderCanvas: true,
        showVideoPlane: false,
        VideoSrc:"",
        AnnotationId:"",
        LowModelOrbit: false
    }
)

const statePlayerSwitch = proxy ({
   playerWoman:false,
   charSwitchClicked: false,
   characterUiOn: false
    
    
    })

  const stateMDR = proxy ({
    museaumActive: ""
     
     
     })

     const stateSound = proxy ({
        backAudio: true
         
         
         })

         const stateImageGallery = proxy ({
            galleryOn: false,
            galleryIndex: ""
             
             
             })

             const stateMemory = proxy (
                {
                    memoryLowDevice: false,
                    performanceLowDevice: false,
                    scetchfabOff: true,
                    lowModelCamZoom: 10,
                    deviceToOld:false
                }
             )
    
             const stateEnglisch = proxy ({
                isEnglisch: false
                 
                 
                 })

                 const stateMDRText = proxy ({
                    isRegional: false,
                    isPrimaer:false
                     
                     
                     })

const stateArtefactTexts = proxy({
    Titel: "",
    Text: "",
})

// Signals that content GLBs for each room have resolved (index = activeThemeIndex).
// Set to true by ContentSignal inside each room's inner Suspense.
// RoomShells wait for this before streaming textures.
const stateContentReady = proxy([false, false, false, false, false, false]);

export {
    stateInArea,
    statePlayerPositionS,
    stateOrbitLocation,
    stateUiDisplay,
    stateDevice,
    stateTouchCircle,
    stateWallPush,
statedynamicLight,
stateLoadingScreen,
stateIframeWindow,
stateTouchCircleLook,
statePlayerSwitch,
stateMDR,
stateInAreaRooms,
stateSound,
stateImageGallery,
stateInAreaSchaustelle,
stateMemory,
stateEnglisch,
stateMDRText,
stateNavigation,
stateArtefactTexts,
stateContentReady


}